// extracted by mini-css-extract-plugin
module.exports = {"ul":"_1taS2AzLgCsvW59WlwKqJg","li":"_35BMV-QWXQMH4OK_zbxGrv","link":"_2HSAYmX5zSZ950xlpP_bUO"};